import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export function getWebPushNotificationsOption() {
    var options = getOptionsForFeature(OwsOptionsFeatureType.WebPushNotifications);
    return options;
}
//# sourceMappingURL=getWebPushNotificationsOption.js.map